import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-project-icon-colored",
  "use": "svg-project-icon-colored-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-project-icon-colored\"><path style=\"stroke:none;fill-rule:evenodd;fill:#70aef2;fill-opacity:1\" d=\"M0 .934v11.183h.934V.934h22.132v22.132H11.883V24H24V0H0Zm0 0\" /><path style=\"stroke:none;fill-rule:nonzero;fill:#8cbe3f;fill-opacity:1\" d=\"M6.762 17.578V6.762l10.816 5.406Zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol